// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"82":"860fb5f27c64acad","6814":"010e8c6b55649214"}[chunkId] + ".js";
};